import { Button, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import Page from "src/components/Page";
import { contactus } from "../Model/Auction";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import { Helmet } from "react-helmet";
import "./contact.css";

function Contact(props) {
  const [state, setState] = React.useState({
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal } = state;
  const [inquireMessage, setInquireMessage] = React.useState("");
  const [openNotif, setOpenNotif] = React.useState(false);

  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleClosess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenNotif(false);
  };

  function sendHandle(event) {
    event.preventDefault();

    const ArrayData = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      subject: values.subject,
      message: values.message,
    };
    setLoading(true);

    async function postContact() {
      const results = await contactus(ArrayData);
      setLoading(false);
      setOpenNotif(true);
      setInquireMessage(results.msg);
    }
    postContact().catch((error) => {
      setLoading(false);
      setInquireMessage(error.response.data.msg);
      //return error.response.data.message;
    });
  }

  //     const callMeta = async () => {
  //       let dataSend = {
  //         title: 'Contact Leon Gallery | Reach Out to the Philippines Premier Art Auction House',
  //         discription: 'Have questions about art auctions, consignments, or exhibitions? Contact Leon Gallery in Makati via email, phone, or visit us in person.',
  //         lotNo: '',
  //         canonical: 'https://leon-gallery.com/contact',
  //         url: 'https://leon-gallery.com/contact',
  //         imagUrl: 'https://leon-gallery.com/static/media/dddd.f96bbcbee8c8c2f5e3ee.png',
  //       };

  //       await fetch(`https://leon-gallery.com/meta`, {
  //         method: "POST",
  //         body: JSON.stringify(dataSend),
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //       })
  //         .then((response) => response.json())
  //         .then((data) => {
  //           console.log("data send here ", data);
  //         })
  //         .catch((error) => {
  //           // alert.error(error)
  //           console.log("error ", error);
  //         });
  //     }

  // useEffect(() => {
  //   return callMeta();

  // },[])

  return (
    <>
      <Helmet>
        <title>Leon Gallery | Contact Us</title>
        <meta property="fb:app_id" content="1020360273385521"/> 
        <meta
          name="description"
          content="Get in touch with Leon Gallery for inquiries about our collections, upcoming auctions, or art-related services. We are here to assist you with your art journey."
        />
        <meta property="og:title" content="Contact Leon Gallery" />
        <meta
          property="og:description"
          content="Reach out to Leon Gallery for questions, inquiries, and more. Our team is ready to assist you in purchasing, consigning, or learning more about Philippine art."
        />
      </Helmet>
      
      <div className="container" style={{ paddingTop: 30 }}>
        <nav style={{ paddingBottom: 30 }}>
          <ol className="breadcrumb" style={{ backgroundColor: "#fff" }}>
            <li className="breadcrumb-item">
              <a href="/home">Home</a>
            </li>
            <li className="breadcrumb-item">
              <a style={{ color: "#000000" }} href="#">
                Contact Us
              </a>
            </li>
          </ol>
        </nav>

  

        <div class="contact-container">
  <div class="left-column">
    <div class="contact-info">
      <h2>Contact Info</h2>
      <p><strong>Eurovilla 1:</strong> (02) 8856 2781</p>
      <p><strong>La Fuerza:</strong> (8772-8343/5310-3534</p>

      <p><strong>E</strong> <a href="mailto:info@salcedoauctions.com">info@leon-gallery.com</a></p>
      <div class="social-icons">
      <a href="https://www.facebook.com/LeonGalleryMakati/"  target="_blank"><i class="fa fa-facebook-f"></i></a>


        <a  href="https://www.instagram.com/leongallerymakati"
                        target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
        <a  href="https://www.youtube.com/channel/UCcgsLbrD84mc26EuWzVptzA"
                        target="_blank"><i className="fa fa-youtube-play" aria-hidden="true"></i></a>
      </div>
    </div>

    {/* <div class="subscribe">
      <h2>Subscribe</h2>
      <p>Enter your email to receive updates on upcoming auctions, exclusive previews, and art news from León Gallery.</p>
      <form>
        <input type="email" placeholder="E-mail Address" required />
        <Button
                              type="submit"
                              className="btn-two"
                              variant="contained"
                              style={{
                                // width: "100%",
                                height: 45,
                                background: "#212529",
                              }}
                            >
                              SUBSCRIBE
                            </Button>

      </form>
    </div> */}
  </div>

  <div class="right-column">
    <h2>Contact Form</h2>
    <p>Have a question or request?
We’re here to help. Whether you’re interested in consigning, bidding, or learning more about Philippine art, our team is ready to assist you. Fill out the form below and we’ll get back to you promptly.</p>
    <form onSubmit={sendHandle}>
                      <Grid container spacing={1}>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            id="outlined-select-currency-native"
                            margin="normal"
                            fullWidth
                            label="Name"
                            name="name"
                            // value={values.roles}
                            onChange={handleChange}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            // error={errorUsername ? true : false}
                            // helperText={validUsername}
                            // inputProps={{pattern:"[a-zA-Z0-9\-\_]$"}}
                            fullWidth
                            label="Email"
                            margin="normal"
                            name="email"
                            onChange={handleChange}
                            type="email"
                            // value={values.username}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            fullWidth
                            label="Subject"
                            margin="normal"
                            name="subject"
                            // error={error ? true : false}
                            onChange={handleChange}
                            type="text"
                            // value={values.password}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            fullWidth
                            // error={error ? true : false}
                            // helperText={valid}
                            label="Phone Number"
                            margin="normal"
                            name="phone"
                            onChange={handleChange}
                            type="number"
                            // value={values.confirm}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            // error={error ? true : false}
                            // helperText={valid}
                            label="Your Message"
                            margin="normal"
                            name="message"
                            multiline
                            rows={4}
                            onChange={handleChange}
                            type="text"
                            // value={values.confirm}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <div className="view-more-button">
                            <Button
                              type="submit"
                              className="btn-two"
                              variant="contained"
                              style={{
                                // width: "100%",
                                height: 45,
                                background: "#212529",
                              }}
                            >
                              Send
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </form>
  </div>
</div>


        {/* <section class="" style={{width: 700,margin: 'auto'}}>
          
          <div class="">
            <div class="sec-title text-center" style={{ paddingBottom: 35 }}>
              <div class="big-title">
                <h1>Get in Touch</h1>
              </div>
              
            </div>
            <div class="row clearfix">
              <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="">
                  <div class="">
                    <form onSubmit={sendHandle}>
                      <Grid container spacing={1}>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            id="outlined-select-currency-native"
                            margin="normal"
                            fullWidth
                            label="Name"
                            name="name"
                            // value={values.roles}
                            onChange={handleChange}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            // error={errorUsername ? true : false}
                            // helperText={validUsername}
                            // inputProps={{pattern:"[a-zA-Z0-9\-\_]$"}}
                            fullWidth
                            label="Email"
                            margin="normal"
                            name="email"
                            onChange={handleChange}
                            type="email"
                            // value={values.username}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            fullWidth
                            label="Subject"
                            margin="normal"
                            name="subject"
                            // error={error ? true : false}
                            onChange={handleChange}
                            type="text"
                            // value={values.password}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            required
                            fullWidth
                            // error={error ? true : false}
                            // helperText={valid}
                            label="Phone Number"
                            margin="normal"
                            name="phone"
                            onChange={handleChange}
                            type="number"
                            // value={values.confirm}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            // error={error ? true : false}
                            // helperText={valid}
                            label="Your Message"
                            margin="normal"
                            name="message"
                            multiline
                            rows={4}
                            onChange={handleChange}
                            type="text"
                            // value={values.confirm}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <div className="view-more-button">
                            <Button
                              type="submit"
                              className="btn-two"
                              variant="contained"
                              style={{
                                width: "100%",
                                height: 45,
                                background: "#212529",
                              }}
                            >
                              Send
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        style={{ margin: "auto", position: "absolute" }}
        open={openNotif}
        autoHideDuration={5000}
        onClose={handleClosess}
        message={inquireMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        key={vertical + horizontal}
      />
    </>
  );
}

export default Contact;
